// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    TAG_ALL_FEED_LOADING() {
      return {
        isLoading: true,
        tagAllFeed: action.tagAllFeed,
        allRendered: false
      };
    },
    TAG_ALL_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.tagAllFeed,
        allRendered: false
      };
    },
    TAG_ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagAllFeed.errorMessage
      };
    },
    TAG_ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: false,
        data: state.data,
        allRendered: true
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
